import { createSelector } from "@reduxjs/toolkit"
import { ColorDtoDelekComponentDto } from "api"

// export const selectedColorSelector = createSelector<
//   RootState,
//   ColorState["colors"][number] | undefined
// >(
//   (state) => state.color.colors,
//   (state) => state.color.selectedColorCode,
//   (colors, selectedColorCode) =>
//     colors.find((color): => color.details.code === selectedColorCode)
// )
export const selectedColorSelector = createSelector(
  (state: any) => state.color.colors as ColorDtoDelekComponentDto[],
  (state: any) => state.color.selectedColorCode,
  (colors, selectedColorCode): ColorDtoDelekComponentDto | undefined =>
    colors?.find((color) => color.details.code === selectedColorCode)
)
